module.exports = __webpack_public_path__ + "img/zixun_qrcode.eacf946f.png";